var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isInitLoading)?_c('transition',{attrs:{"name":"el-fade-in-linear"}},[_c('div',{staticClass:"InitLoadingBox"},[_c('div',{staticClass:"InitLoading"},[_c('img',{attrs:{"src":_vm.loadingImg}}),_vm._v(" 页面进入中.. ")])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }